import Orb from '../../components/base/Orb';
import RadioPlayer from '../../components/base/RadioPlayer';
import { useStationCount } from '../../hooks/useStationCount';

export default function Home() {
  const stationCount = useStationCount();
  return (
    <div className="min-h-screen font-sans relative overflow-hidden bg-black">
      {/* Animated Orb Background */}
      <div className="absolute inset-0 z-0">
        <Orb hue={270} hoverIntensity={0.3} rotateOnHover={true} />
      </div>

      {/* Content */}
      <div className="relative z-10 min-h-screen pointer-events-none">
        {/* Header */}
        <header className="w-full py-5 px-8 pointer-events-auto">
          <div className="container mx-auto flex justify-between items-center">
            <a href="#" className="text-2xl text-white">
              <svg width="174" height="30" viewBox="0 0 523 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_3083_224)">
                  <path d="M40.1211 29.5088V0H50.5359V29.5088H40.1211Z" fill="#4F39F6" />
                  <path d="M37.1319 49.1947L0 34.3419L3.86799 24.6719L45.3293 41.2565L86.7906 24.6719L90.6586 34.3419L53.7082 49.1221L80.6748 83.5793L72.473 89.9981L45.4477 55.4658L20.0082 89.884L11.6328 83.6935L37.1319 49.1947Z" fill="#4F39F6" />
                  <path d="M104.333 89V-0.740004H115.486V78.744H156.382V89H104.333ZM178.501 89V9.516H149.399V-0.740004H218.756V9.516H189.654V89H178.501ZM229.904 89V-0.740004H264.261C282.209 -0.740004 294.132 10.0288 294.132 26.823C294.132 39.3866 286.568 49.1298 275.03 52.3348L295.158 89H282.594L263.62 54.5142H241.057V89H229.904ZM241.057 44.2582H263.364C275.158 44.2582 282.722 37.3354 282.722 26.823C282.722 16.3106 275.158 9.516 263.492 9.516H241.057V44.2582ZM312.772 89.7692C308.542 89.7692 305.465 86.9488 305.465 82.59C305.465 78.2312 308.542 75.4108 312.772 75.4108C317.003 75.4108 320.08 78.2312 320.08 82.59C320.08 86.9488 317.003 89.7692 312.772 89.7692ZM359.033 89.7692C339.932 89.7692 326.599 76.18 326.599 56.309C326.599 36.438 339.932 22.8488 359.033 22.8488C378.135 22.8488 391.468 36.438 391.468 56.309C391.468 76.18 378.135 89.7692 359.033 89.7692ZM359.033 80.4106C371.982 80.4106 380.699 70.2828 380.699 56.309C380.699 42.3352 371.982 32.2074 359.033 32.2074C346.085 32.2074 337.368 42.3352 337.368 56.309C337.368 70.2828 346.085 80.4106 359.033 80.4106ZM418.976 89L394.49 23.618H405.771L425.514 77.0774L445.129 23.618H456.154L431.668 89H418.976ZM464.88 89V-0.740004H475.393V32.4638C479.239 27.5922 485.905 22.8488 496.93 22.8488C511.673 22.8488 523.34 30.9254 523.34 52.5912V89H512.827V53.2322C512.827 39.643 506.545 32.4638 495.264 32.4638C482.059 32.4638 475.393 40.6686 475.393 54.5142V89H464.88Z" fill="white" />
                </g>
                <defs>
                  <clipPath id="clip0_3083_224">
                    <rect width="523" height="90" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
            <div className="flex items-center gap-4">
              <a href="mailto:hello@ltr.ovh">
                <button className="px-4 py-2 bg-white text-gray-900 text-sm rounded-full whitespace-nowrap hover:bg-gray-100 transition-all cursor-pointer">
                  Reach out <i className="ri-external-link-line text-black"></i>
                </button>
              </a>
              <button className="w-10 h-10 flex items-center justify-center bg-white/10 backdrop-blur-sm border border-white/20 rounded-full cursor-pointer hover:bg-white/20 transition-all">
                <i className="ri-question-line text-white"></i>
              </button>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="container mx-auto px-8 flex items-center min-h-[80vh] pointer-events-auto">
          <div className="flex flex-col items-center text-center max-w-4xl mx-auto w-full">
            {/* Hero Title */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8 tracking-tight text-white text-center max-w-[90%] xl:max-w-[80%] 2xl:max-w-[70%] mx-auto">
              Redefining the way you <span className='font-light'>listen to radio.</span>
            </h1>

            {/* Radio Player */}
            <div className="mb-8 w-full">
              <RadioPlayer />
            </div>

            {/* Stream Counter */}
            <div className="mb-6">
              <div className="flex items-center gap-2 text-gray-300 justify-center">
                <i className="ri-rfid-line"></i>
                <span className="text-sm">{stationCount} radio streams</span>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
